module.exports = __webpack_public_path__ + "img/google_pay.b2eb45f2.svg";